import Vue from 'vue'
import Toasted from 'vue-toasted'

// please FIXME Obiwan Kenobi
Vue.use(Toasted, {
    iconPack: 'fontawesome'
})
